export default __webpack_public_path__ + "static/media/envelope-simple-white.f7f39b43.svg";